import { DmmMenu } from "./dmm-menu";
import * as Styles from "./style";
import { Logo } from "~/components/blocks/layout/global-navi/common/logo";
import { DmmServiceDesktop } from "~/components/blocks/layout/global-navi/desktop/left/dmm-service";

export const Left = () => {
  return (
    <Styles.DivWrapper>
      <DmmServiceDesktop />
      <Logo />
      <DmmMenu />
    </Styles.DivWrapper>
  );
};
